import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import tr from './locales/tr/common.json'
import nl from './locales/nl/common.json'
import en from './locales/en/common.json'
import trLanding from './locales/tr/landing.json'
import nlLanding from './locales/nl/landing.json'
import enLanding from './locales/en/landing.json'
import trPages from './locales/tr/pages.json'
import nlPages from './locales/nl/pages.json'
import enPages from './locales/en/pages.json'

export const SUPPORTED_LANGUAGES = ['tr', 'nl', 'en'] as const
export type Language = (typeof SUPPORTED_LANGUAGES)[number]

// Native language names for the switcher (per product decision: show native names).
export const LANGUAGE_NAMES: Record<Language, string> = {
  tr: 'Türkçe',
  nl: 'Nederlands',
  en: 'English',
}

// localStorage key — mirrors the convention used by useTheme ('ai-grader-theme').
export const LANGUAGE_STORAGE_KEY = 'ai-grader-lang'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { common: tr, landing: trLanding, pages: trPages },
      nl: { common: nl, landing: nlLanding, pages: nlPages },
      en: { common: en, landing: enLanding, pages: enPages },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    defaultNS: 'common',
    ns: ['common', 'landing', 'pages'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
  })

export default i18n
